import { Stack } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import {
  CIRCLE_UNICODE,
  LOCALE_EN,
  DASH,
} from "../../../Constants/CommonConstants";
import {
  PROVIDER_SITE_INFO_DOB,
  PROVIDER_SITE_INFO_EMAIL,
  PROVIDER_SITE_INFO_EMAIL_LANGUAGE,
  PROVIDER_SITE_INFO_FIRST_NAME,
  PROVIDER_SITE_INFO_HAS_PROF_LICENSE_NUMBER,
  PROVIDER_SITE_INFO_LAST_NAME,
  PROVIDER_SITE_INFO_MIDDLE_NAME,
  PROVIDER_SITE_INFO_PASSWORD,
  PROVIDER_SITE_INFO_PROF_LICENSE_NUMBER,
  PROVIDER_SITE_INFO_USER_NAME,
} from "../../../Constants/ProviderAndCertifierAccountCreationConstants";
import { manageProviderAccountCreationSelector } from "../../../Selectors/ProviderAccountCreationSelector";
import { manageReferenceDataSelector } from "../../../Selectors/ReferenceDataSelector";
import { getHasProfLicenseNoValue } from "../../../Services/CommonServices";
import ReviewFieldDisplay from "../../AccountCreation/ReviewYourInformation/ReviewFieldDisplay";
import { manageLocaleSelector } from "../../../Selectors/LocaleSelector";

/**
 * @description Uses the ReviewFieldDisplay to statically render text on the UI.
 * @returns {ReactNode} React component consisting of heading and ProviderReviewInfoFields.
 */
const ProviderReviewInfoFields = () => {
  const {
    dob,
    email,
    username,
    password,
    firstName,
    middleName,
    lastName,
    profLicenseNo,
    emailLanguage,
    hasProfLicenseNo,
  } = useSelector((state) => manageProviderAccountCreationSelector(state));

  const { language } = useSelector((state) => manageLocaleSelector(state));

  const { commonYesNo } = useSelector((state) =>
    manageReferenceDataSelector(state)
  );

  return (
    <Stack spacing={2.5}>
      <ReviewFieldDisplay
        fieldLabelId={PROVIDER_SITE_INFO_FIRST_NAME}
        fieldData={firstName}
      />
      <ReviewFieldDisplay
        fieldLabelId={PROVIDER_SITE_INFO_MIDDLE_NAME}
        fieldData={middleName}
      />
      <ReviewFieldDisplay
        fieldLabelId={PROVIDER_SITE_INFO_LAST_NAME}
        fieldData={lastName}
      />
      <ReviewFieldDisplay
        fieldLabelId={PROVIDER_SITE_INFO_EMAIL}
        fieldData={email}
      />
      <ReviewFieldDisplay
        fieldLabelId={PROVIDER_SITE_INFO_EMAIL_LANGUAGE}
        fieldData={
          language === LOCALE_EN
            ? emailLanguage?.displayEn
            : emailLanguage?.displayEs
        }
      />
      <ReviewFieldDisplay
        fieldLabelId={PROVIDER_SITE_INFO_HAS_PROF_LICENSE_NUMBER}
        fieldData={getHasProfLicenseNoValue(commonYesNo, hasProfLicenseNo)}
      />
      <ReviewFieldDisplay
        fieldLabelId={PROVIDER_SITE_INFO_PROF_LICENSE_NUMBER}
        fieldData={profLicenseNo || DASH}
      />
      <ReviewFieldDisplay
        fieldLabelId={PROVIDER_SITE_INFO_DOB}
        fieldData={dob}
      />
      <ReviewFieldDisplay
        fieldLabelId={PROVIDER_SITE_INFO_USER_NAME}
        fieldData={username}
      />
      <ReviewFieldDisplay
        fieldLabelId={PROVIDER_SITE_INFO_PASSWORD}
        fieldData={CIRCLE_UNICODE.repeat(password?.length)}
      />
    </Stack>
  );
};

export default ProviderReviewInfoFields;
